module.exports = __webpack_public_path__ + "static/media/bulklinklogo.a4b39b4b.png";